<!-- Router outlet to display routed components -->
<router-outlet></router-outlet>
